import React from 'react';
import { Field } from 'redux-form';
import getLocaleMessages from '../../../utils/localesMessages';
import { BodyText, CaptionText } from '@paypalcorp/pp-react';
import TextAreaWithByteCounter from '../../fields/TextAreaWithByteCounter';

const MAX_BYTE_LIMIT = 127;
const {
  title,
  subTitle,
  text: { label },
  counter: { ariaLabel },
} = getLocaleMessages('buttonsV3/purpose');

const renderPurposeTextArea = (props) => {
  return <TextAreaWithByteCounter {...props} />;
};

function Purpose() {
  return (
    <div className="purpose-container">
      <BodyText strong className="purpose-title">
        {title}
      </BodyText>
      <CaptionText className="purpose-subtitle">{subTitle}</CaptionText>
      <Field
        id="purpose"
        name="purpose"
        component={renderPurposeTextArea}
        textLabel={label}
        counterLabel={ariaLabel}
        maxByteLimit={MAX_BYTE_LIMIT}
      />
    </div>
  );
}

export default Purpose;
